import React from 'react';
import { Brain, Search, Target } from 'lucide-react';

const Vectors: React.FC = () => {
  return (
    <div className='space-y-8'>
      <div>
        <h1 className='text-3xl font-bold text-gray-900'>AI-Powered Vector Search</h1>
        <p className='text-gray-600 mt-2'>
          Semantic similarity search with machine learning embeddings and cloud-native vector
          indexes
        </p>
      </div>

      <div className='grid md:grid-cols-3 gap-6'>
        <div className='card bg-gradient-to-r from-blue-50 to-purple-50 border-blue-200'>
          <div className='flex items-center space-x-3 mb-4'>
            <Brain className='w-8 h-8 text-blue-600' />
            <h3 className='text-lg font-semibold'>Embedding Generation</h3>
          </div>
          <p className='text-gray-600 text-sm mb-4'>
            Convert text and data into high-dimensional vectors using Cloudflare Workers AI
          </p>
          <button className='btn btn-primary w-full'>Generate Embeddings</button>
        </div>

        <div className='card bg-gradient-to-r from-green-50 to-emerald-50 border-green-200'>
          <div className='flex items-center space-x-3 mb-4'>
            <Search className='w-8 h-8 text-green-600' />
            <h3 className='text-lg font-semibold'>Semantic Search</h3>
          </div>
          <p className='text-gray-600 text-sm mb-4'>
            Find similar content using cosine similarity, euclidean distance, and dot product
          </p>
          <button className='btn btn-secondary w-full'>Search Vectors</button>
        </div>

        <div className='card bg-gradient-to-r from-purple-50 to-pink-50 border-purple-200'>
          <div className='flex items-center space-x-3 mb-4'>
            <Target className='w-8 h-8 text-purple-600' />
            <h3 className='text-lg font-semibold'>Hybrid Search</h3>
          </div>
          <p className='text-gray-600 text-sm mb-4'>
            Combine vector similarity with traditional database filters for precision
          </p>
          <button className='btn btn-success w-full'>Hybrid Search</button>
        </div>
      </div>

      <div className='card'>
        <h3 className='text-2xl font-bold text-gray-900 mb-6'>Vector Search Demo</h3>
        <div className='bg-gray-50 rounded-lg p-6'>
          <p className='text-gray-600'>
            Interactive vector search demonstration will be implemented here.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Vectors;
